import apiClient from '@/services/axios'

export async function post(payload) {
  // Debug: Log what we're sending to the API
  console.log('API - About to POST to /rewards with:', {
    maxRecurringCount: payload.maxRecurringCount,
    maxRecurringRewardPeriod: payload.maxRecurringRewardPeriod,
    isRecurring: payload.isRecurring
  });
  
  var response = await apiClient.post('/rewards', payload)
  if (response) {
    return response.data
  }

  throw new Error('Unable to add reward.')
}